import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { unstable_extendSxProp as extendSxProp } from '@mui/system';

/**
 * AppBox — Design System layout primitive.
 *
 * Thin forwardRef wrapper over MUI Box. All MUI Box props are supported.
 * Use this instead of importing Box directly from @mui/material within the Design System.
 * MUI 9 Box no longer reads system props (display, gap, mt, …), so they are moved into `sx` here.
 */
const AppBox = React.forwardRef(({ children, ...props }, ref) => (
  <Box ref={ref} {...extendSxProp(props)}>
    {children}
  </Box>
));

AppBox.displayName = 'AppBox';

AppBox.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AppBox;
